import classNames from "classnames";

import {formatNumber} from "../../../core/util/number/numberUtils";
import Typography, {TypographyOwnProps} from "../../../component/typography/Typography";

interface AccountBalanceProps {
  amount: number;
  unit?: string;
  typographyProps?: Omit<TypographyOwnProps, "children" | "as">;
}

function AccountBalance({amount, unit, typographyProps}: AccountBalanceProps) {
  const formattedAmount = formatNumber()(amount);

  return (
    <Typography
      as={"p"}
      {...typographyProps}
      customClassName={classNames("account-balance", typographyProps?.customClassName)}>
      {unit ? `${formattedAmount} ${unit}` : formattedAmount}
    </Typography>
  );
}

export default AccountBalance;
